import {
  AdvancedBookingApiDetails,
  AdvancedBookingCardTypeEnum,
  ICommodity,
  ICommoditySearchResult,
  IRequirementSearchTemplate,
  LoadTypeEnum,
  MeasurementSystemEnum,
  QuoteActionEnum,
  QuoteStatusEnum,
} from "@cai-services";
import { LoadTypeUnit } from "../../components/load-type/model/load-type-unit.model";
import { BUP } from "./bup.model";
import { Dimension } from "./dimension.model";
import { Quote } from "./quote.model";

export class AdvancedBookingDetails {
  shipmentId: number;
  favoriteId: number;
  shipmentStatus: QuoteStatusEnum;
  airline: string;
  origin: string;
  destination: string;
  flightNo: string;
  allotmentCode: string;
  awb: string;
  goodsType: string;
  departureDate: Date | string;
  weight: number;
  volume: number;
  pieces: number;
  requested?: boolean;
  loadTypeMode?: LoadTypeEnum;
  measurementSystem?: MeasurementSystemEnum;
  chargeableWeight?: number;
  commodityWithParent?: ICommodity;
  commodityResult?: ICommoditySearchResult;
  bups: BUP[] = [];
  dimensions: Dimension[] = [];
  commodities: ICommodity[] = [];
  requirements?: IRequirementSearchTemplate[] = [];
  isFromSuggestion?: boolean;
  isFavorite?: boolean;
  ApiRawData?: AdvancedBookingApiDetails;
  possibleActions?: QuoteActionEnum[];
  quote?: Quote;
  airlineCompanyName?: string;
  isEditable?: boolean;
  loadTypeUnit?: MeasurementSystemEnum;
  dimensionTypeUnit?: MeasurementSystemEnum;
  bupTypeUnit?: MeasurementSystemEnum;
  loadTypeUnitState?: { [key: string]: LoadTypeUnit };
  index?: number;
  cardType?: AdvancedBookingCardTypeEnum;
}
